import { studentsAPI, usersAPI } from '../services/api';
import { mapUserStudentToEditForm } from './mapUserStudentToEditForm';

/**
 * Load user+student the same way as Edit User / Filter Students inline edit.
 * @returns {Promise<{ formData: object, userId: string, student: object, user: object }>}
 */
export async function loadStudentForAdminEdit({ studentId, email }) {
  if (!studentId && !email) {
    throw new Error('studentId or email is required');
  }

  let student = null;
  if (studentId) {
    const studentRes = await studentsAPI.getById(studentId);
    student = studentRes.data;
  }

  const resolvedEmail =
    student?.emailAddress || student?.email || email || null;
  if (!resolvedEmail) {
    throw new Error('Student email missing — cannot load Edit User form');
  }

  const userRes = await usersAPI.getByEmail(resolvedEmail);
  const user = userRes.data;
  const userId = user?.id || user?._id;
  if (!userId) {
    throw new Error(`No user account for ${resolvedEmail}`);
  }

  if (!student) {
    throw new Error(`No student record for ${resolvedEmail}`);
  }

  const formData = mapUserStudentToEditForm(user, student);
  return { formData, userId: String(userId), student, user };
}
